import React from 'react';
import styled from 'styled-components';
import {motion} from 'framer-motion';
import {MainBtnVariants} from '../animations/MainPageAnims';
import { BsChevronDoubleDown } from 'react-icons/bs';

function DownBtn() {

    const ClickHandler = ()=>{
        window.scrollTo({
            top: window.innerHeight+10,
            behavior: 'smooth'
        });
    }

  return (
    <BtnContainer>
      <Btn
      variants={MainBtnVariants} initial="initial" animate="animate"
      onClick={ClickHandler} ><BsChevronDoubleDown strokeWidth={1} size={19} /></Btn>
    </BtnContainer>
  );
}

const BtnContainer = styled.div`
  overflow: hidden;
  position: relative;
  transition: all 0.8s ease;
  margin-top: 2rem;
  /* border: 2px solid white; */
  &:hover{
    transform: translate(0px, -10%);
  }

  @media only screen and (max-width: 500px){
    display: none;
  }

  `;

const Btn= styled(motion.button)`
    background-color: var(--secondary);
    font-size: 1rem;
    padding: 1.1rem 1.6rem;
    border: none;
    border-radius: 35px;
    color: var(--white);
    font-weight: bold;
    letter-spacing: 0.1em;
    align-self: flex-start;
    cursor: pointer;

`;

export default DownBtn;